<template>
  <div>
    <div v-for="(f, i) in searches" :key="i" class="">
      <div
        v-if="f.flag == 8"
        class="bg-light pd-y-5 pd-l-10 text-uppercase tx-11 tx-color-03 bd-b mg-b-10"
      >
        {{ f.title }}
      </div>
      <div v-else class="pd-x-10-f pd-y-0-f mg-b-20">
        <div class="form-group">
          <div>
            <label class="mg-b-0 text-uppercase tx-10"
              >{{ i + 1 }}). {{ f.title }}</label
            >
          </div>
          <input
            v-if="f.flag == 1"
            v-model="$data['filterModel'][f.field]"
            type="text"
            class="form-control form-control-sm"
            placeholder=""
          />
          <loc-type-cascader
            v-else-if="f.flag == 3"
            :id="$data['filterModel'][f.field]"
            v-model="$data['filterModel'][f.field]"
            :getParentType="true"
            :locTypekey="f.key"
            checkStrictly
          />
          <DatePicker
            v-else-if="f.flag == 6"
            v-model="$data['filterModel'][f.field]"
            class="wd-100p-f"
          ></DatePicker>
          <DatePicker
            v-else-if="f.flag == 7"
            v-model="$data['filterModel'][f.field]"
            type="year"
            class="wd-100p-f"
          ></DatePicker>
          <!-- <Select v-else-if="f.flag==12" v-model="$data['filterModel'][f.field]" filterable clearable size="mini" class="wd-100p-f">
                  <Option :value="null" label="Бүгд"></Option>
                  <Option :value="1" label="Тийм"></Option>
                  <Option :value="0" label="Үгүй"></Option>
                </Select> -->
                <drop-down-int
            v-else-if="f.flag == 12"
            v-model="$data['filterModel'][f.field]"
          ></drop-down-int>
          <drop-down
            v-else-if="f.flag == 33"
            v-model="$data['filterModel'][f.field]"
          ></drop-down>
          <!-- <div v-else-if="f.flag == 24 " class="btn btn-xs btn-block btn-outline-primary btn-uppercase">
                  сонгох
                </div> -->
                <input
            v-else-if="f.flag == 15"
            v-model="$data['filterModel'][f.field]"
            type="number"
            class="form-control form-control-sm"
            placeholder=""
          />
          <task-finder
            v-else-if="f.flag == 24 || f.flag == 85"
            v-model="$data['filterModel'][f.field]"
            :selectedId="$data['filterModel'][f.field]"
            @on-task-selected="f.cstmFld2 = $event.task"
            :objectTypeId.sync="[f.key][0]"
            :key="`tsk_${i}`"
          ></task-finder>
          <depart-cascader
            v-else-if="f.flag == 30"
            v-model="$data['filterModel'][f.field]"
            :id="$data['filterModel'][f.field]"
            checkStrictly
          ></depart-cascader>
          <Select
            v-else-if="f.flag == 45"
            placeholder="сонгоно уу"
            v-model="$data['filterModel'][f.field]"
            clearable
            class="wd-100p-f"
          >
            <Option :value="null" label="Бүгд">Бүгд</Option>
            <Option :value="1" label="Системийн">Системийн</Option>
            <Option :value="6" label="Системийн бус">Системийн бус</Option>
          </Select>
          <user-chooser
            v-else-if="f.flag == 75"
            :f="f"
            @on-handle="handleUserSelected"
          ></user-chooser>
          <cmms-finder
            :key="cmmsKey"
            v-else-if="f.flag == 99"
            :f="f"
            ref="cmmsFinder"
            @on-add-item="$emit('on-add-item', $event)"
            @on-add-item-root="$emit('on-add-item-root', $event)"
            @on-edit-item="$emit('on-edit-item', $event)"
            @on-site-detail="$emit('on-site-detail', { mode: 80, obj: $event })"
            @on-site-edit="$emit('on-site-edit', $event)"
            @on-site-add="$emit('on-site-add', $event)"
            @on-site="onSite"
            @on-change="onAsset"
            @on-add-work="$emit('on-add-work', $event)"
            @on-item-detial="$emit('on-item-detial', { mode: 80, obj: $event })"
          />

          <div v-else>{{ f.flag }}</div>

          <!-- 
                       -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { Select, Option, DatePicker } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Select,
    Option,
    DatePicker,
    dropDown: () => ({
      component: import("@/components/task/edit/components/dropDown"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
     dropDownInt: () => ({
      component: import("@/components/task/edit/components/dropDownInt"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userChooser: () => ({
      component: import("@/components/user/chooser.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    cmmsFinder: () => ({
      component: import("@/components/task/list/components/cmmsFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    allCount: {
      type: Number,
      default: () => 0
    },
    tasksCount: {
      type: Number,
      default: () => 0
    },
    searches: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterModel: {
        task: "",
        systemFlag: null
      },
      cmmsKey: 0
    };
  },
  mounted() {
    if (this.$route.params.ot != undefined && this.$route.params.ot == "390") {
      this.filterModel.systemFlag = 6;
    }
    //console.log('search comp mounted', this.searches);
  },
  methods: {
    filter() {
      //console.log('fired from modal');
      this.$emit("on-search", this.filterModel);
    },
    reset() {
      this.filterModel = {
        task: "",
        systemFlag: null
      };
      this.$emit("on-search", this.filterModel);
    },
    handleUserSelected(e) {
      //console.log('handleUserSelected=> before', e, this.filterModel);
      if (e.val == null || e.val == "") {
        this.$delete(this.$data["filterModel"], e.field);
      } else {
        //this.$data['filterModel'][e.field]= e.val;
        this.filterModel[e.field] = e.val;
      }
      //console.log('handleUserSelected=> ', e);
      this.$emit("on-search", this.filterModel);
    },
    export() {
      this.$emit("on-export", this.filterModel);
    },

    //## CMMS
    onAddItemRoot(e) {
      // this.taskEdit.id = 0;
      // this.taskEdit.objectTypeId = this.ot;
      // this.taskEdit.projectId = this.project.id;
      // this.taskEdit.organizationTaskId = e.id;
      // this.taskEdit.parentTask = {
      //   //id: e.id
      //   organizationTaskId: e.id,
      // };
      // this.taskEdit.render = true;
      // this.$nextTick(function() {
      //   this.taskEdit.show = true;
      // });
    },
    onAddItem(e) {
      // this.taskEdit.id = 0;
      // this.taskEdit.objectTypeId = this.ot;
      // this.taskEdit.projectId = this.project.id;
      // //# add ons
      // this.taskEdit.boxId = e.boxId;
      // this.taskEdit.parentId = e.id;
      // this.taskEdit.parentTask = {
      //   id: e.id,
      //   locTypeId: e.locTypeId,
      //   organizationTaskId: e.organizationTaskId,
      //   secondOrganizationTaskId: e.secondOrganizationTaskId,
      //   thirdOrganizationTaskId: e.thirdOrganizationTaskId,
      //   fourthOrganizationTaskId: e.fourthOrganizationTaskId,
      //   taskEn: e.taskEn,
      // };
      // this.taskEdit.render = true;
      // this.$nextTick(function() {
      //   this.taskEdit.show = true;
      // });
    },
    onEdittem(e) {
      // this.taskEdit.id = e.id;
      // this.taskEdit.objectTypeId = this.ot;
      // this.taskEdit.render = true;
      // this.$nextTick(function() {
      //   this.taskEdit.show = true;
      // });
    },
    onSiteEdit(e) {
      // this.taskEdit.id = e.id;
      // this.taskEdit.objectTypeId = e.objectTypeId;
      // this.taskEdit.render = true;
      // this.$nextTick(function() {
      //   this.taskEdit.show = true;
      // });
    },
    onSiteAdd(e) {
      // let prjs = this.$store.state.app.groupDefaultProjects.filter(
      //   (x) => x.objectTypeId == e
      // );
      // if (prjs != undefined && prjs.length) {
      //   this.taskEdit.id = 0;
      //   this.taskEdit.projectId = prjs[0].id;
      //   this.taskEdit.objectTypeId = e;
      //   this.taskEdit.render = true;
      //   this.$nextTick(function() {
      //     this.taskEdit.show = true;
      //   });
      // }
    },
    onAddWork(e) {
      // //console.log(e);
      // this.taskEdit.id = 0;
      // this.taskEdit.objectTypeId = 508;
      // //this.taskEdit.projectId = this.project.id;
      // //# add ons
      // this.taskEdit.boxId = e.workBoxId;
      // this.taskEdit.parentId = e.id;
      // this.taskEdit.parentTask = {
      //   id: e.id,
      //   locTypeId: e.locTypeId,
      //   organizationTaskId: e.organizationTaskId,
      //   secondOrganizationTaskId: e.secondOrganizationTaskId,
      //   thirdOrganizationTaskId: e.thirdOrganizationTaskId,
      //   fourthOrganizationTaskId: e.fourthOrganizationTaskId,
      //   taskEn: e.taskEn,
      // };
      // this.taskEdit.render = true;
      // this.$nextTick(function() {
      //   this.taskEdit.show = true;
      // });
    },
    cmmsReRender(pid, id, parentId) {
      this.cmmsKey++;
      this.$nextTick(() => {
        //console.log(this.$refs.cmmsFinder[0]);
        if (this.$refs.cmmsFinder.length) {
          this.$refs.cmmsFinder[0].loadSiteFromSearch(pid, id, parentId);
        }
      });
    },

    onSite(e) {
      //console.log('onSite fired', e);
      this.$data["filterModel"]["ot"] = null;
      this.$data["filterModel"]["secondOrganizationTaskId"] = null;
      this.$data["filterModel"]["organizationTaskId"] = e;
      this.$emit("on-search", this.filterModel);
    },
    onAsset(e) {
      //console.log('onAsset fired', e);
      this.$data["filterModel"]["ot"] = 506;
      this.$data["filterModel"]["secondOrganizationTaskId"] = e;
      this.$emit("on-search", this.filterModel);
    }
  }
};
</script>

<style></style>
